import { Button } from "primereact/button"
import { DataTable } from "primereact/datatable"
import { useEffect, useMemo, useRef, useState } from "react"
import httpService from "../../services/httpService";
import { ApiEndpoints, Constants } from "../../constants/appConstants";
import { useAppContext } from "../../Context";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import "./DataNoticeComponent.scss"
import {  ReviewStatusCode } from "../ProviderProfile/models";
import { ReviewStatusCode as pfpStatusCode } from ".././P4P/ProviderProfile/models";
import { ProgressSpinner } from "primereact/progressspinner";
import { Calendar } from "primereact/calendar";
import { useAuthContext } from "../../Context/AuthContext";
import { MultiSelect } from "primereact/multiselect";
import { FilterService } from "primereact/api";
import { getClientLocalDate, formatClientLocalDate } from "../../services/dateHelper";

FilterService.register('dateIs', (value: any, filter: any) => {
    if (filter === undefined || filter === null) {
        return true;
    }
    if (value === undefined || value === null) {
        return false;
    }
    const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
    const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
    
    if (!normalizedValue || !normalizedFilter) {
        return false;
    }
    return normalizedValue.getTime() === normalizedFilter.getTime();
});

FilterService.register('dateIsNot', (value: any, filter: any) => {
    if (filter === undefined || filter === null) {
        return true;
    }
    if (value === undefined || value === null) {
        return true;
    }
    const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
    const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
    
    if (!normalizedValue || !normalizedFilter) {
        return true;
    }
    return normalizedValue.getTime() !== normalizedFilter.getTime();
});


type NoticeDataItem = {
    providerType: string;
    providerMpi: string;
    agencyName?: string;
    agencyDataPkg?: string;
    pbcStatus?: string;
    pfpStatus?: string;
    isPbcDecisionLetterPresent?: boolean;
    isPfpDecisionLetterPresent?: boolean;
    pbcDecisionDate?: string;
    pfpDecisionDate?: string;
    isPbcResolutionDecisionLetterPresent?: boolean;
    isPfpResolutionDecisionLetterPresent?: boolean;
    pbcResolutionDecisionDate?: string;
    pfpResolutionDecisionDate?: string;
    pbcStatusCode?:ReviewStatusCode;
    pfpStatusCode?:pfpStatusCode
    // Add other fields as needed
};

interface DataNoticeComponentProps {
    providerType?: string;
    reviewYear?: number;
}

export const DataNoticeComponent = ({ providerType: propProviderType, reviewYear: propReviewYear }: DataNoticeComponentProps = {}) => {

    const [noticeData, setNoticeData] = useState<NoticeDataItem[]>([]);
    const [noticeFilterData, setNoticeFilterData] = useState<NoticeDataItem[]>([]);
    const { reviewYear: contextReviewYear, providerType: contextProviderType } = useAppContext();
    const providerType = propProviderType ?? contextProviderType;
    const reviewYear = propProviderType !== undefined ? propReviewYear : contextReviewYear;
    const [isLoading, setIsLoading] = useState(false);
    const [showDialog,setShowDialog] = useState(false);
    //const [isReviewCompleted,setIsReviewCompleted] = useState(false);
    const [filters, setFilters] = useState<any>(null);
    const [isPbcDisputeActive, setIsPbcDisputeActive] = useState(false);

    const globalSearchKeys = [ 'providerMpi', 'agencyName', 'pbcStatus', 'pfpStatus','pbcDecisionDate','pfpDecisionDate','agencyDataPkg'];
    const baseDefaultColumns = ['agencyName', 'agencyDataPkg', 'pbcStatus','isPbcDecisionLetterPresent','pbcDecisionDate'];
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [confirmType, setConfirmType] = useState<string | null>(null);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const noticeRequestId = useRef(0);
    const {isAdministrator} = useAuthContext();


    useEffect(() => {
        const requestId = ++noticeRequestId.current;
        if(!reviewYear) return
        setFilters({
        global: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        providerType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        providerMpi: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        pbcStatus: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        pfpStatus: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        pbcDecisionDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        pfpDecisionDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        pfpResolutionDecisionDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        pbcResolutionDecisionDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        agencyDataPkg: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    })
        getNoticeData(requestId);
        checkDisputeCycleStatus();
    }, [providerType,reviewYear])


    useEffect(() => {
        const defaultColumns = [
            ...baseDefaultColumns,
            ...(isPbcDisputeActive ? ['isPbcResolutionDecisionLetterPresent', 'pbcResolutionDecisionDate'] : []),
        ];
        setSelectedFields(allColumns.filter(col => defaultColumns.includes(col.field)).map(c => c.field));
    }, [isPbcDisputeActive])

    // useEffect(() => {
    //     if (noticeData) {
    //         const isReviewComplete = noticeData.every(x => x.pbcStatus === ReviewStatusCode.ScoReviewCompleted && (x.pfpStatusCode == null || x.pfpStatusCode === pfpStatusCode.ScoReviewCompleted));
    //         setIsReviewCompleted(isReviewComplete);
    //     }
    // }, [noticeData])

    const checkDisputeCycleStatus = () => {
        httpService.get(`${ApiEndpoints.IsActiveDisputeCycle}/${providerType}`)
            .then((resp: any) => {
                setIsPbcDisputeActive(resp?.data === true);
            }).catch(() => {
                // keep default as false
            });
    };

    const getNoticeData = (requestId = ++noticeRequestId.current) =>{
        setIsLoading(true);
        httpService.get(`${ApiEndpoints.GetNoticeData}?reviewYear=${reviewYear}&providerType=${providerType}`).then((resp: any) => {
            if (requestId !== noticeRequestId.current) return;
            const updatedData = resp?.data.map((item:any)=>({
                ...item,
                agencyName: item.agencyName || '',
                pfpDecisionDate:getDateOnly(item.pfpDecisionDate),
                pbcDecisionDate:getDateOnly(item.pbcDecisionDate),
                pfpResolutionDecisionDate:getDateOnly(item.pfpResolutionDecisionDate),
                pbcResolutionDecisionDate:getDateOnly(item.pbcResolutionDecisionDate),
            }))
            setNoticeData(updatedData);
            setNoticeFilterData(updatedData)
            setIsLoading(false);
        }).catch(() => {
            if (requestId === noticeRequestId.current) {
                setIsLoading(false);
            }
        })
    }

      const getDateOnly = (date: string) => {
        return getClientLocalDate(date);
  };

    // const onGlobalFilterChange = (e: any) => {
    //     const value = e.target.value;
    //     let _filters: any = { ...filters };

    //     _filters['global'].value = value;

    //     setFilters(_filters);
    //     setGlobalFilterValue(value);
    // };

    const handleSearch = (e: any) => {
    let value = "";
    if (Array.isArray(e) && typeof e.join("") == "string") {
      value = e.join("");
    } else value = e.target.value;
    let filtered = noticeData.filter((item: any) =>
      globalSearchKeys.some((key) => {
        const fieldValue = String(item[key]).toLowerCase();
        return fieldValue.includes(value?.toLowerCase());
      })
    );
    if (value == globalFilterValue) {
      value = "";
      filtered = noticeData;
    }

    setGlobalFilterValue(value);
    setNoticeFilterData(filtered);
  };


    const dateFilterTemplate = (options: any) => {
      return (
        <Calendar
          value={options.value}
                    onChange={(e) => {
        const selectedDate = e.value;
        if (selectedDate) {
                const clientDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0);
                options.filterCallback(clientDate, options.index);
        } else {
                options.filterCallback(null, options.index);
        }
}}
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          mask="99/99/9999"
        />
      );
    };
    
    const renderHeader = () => {
        return (
            <div className="flex justify-content-start" style={{gap:'10px'}}>
                <IconField iconPosition="left" className="data-notice-search-field">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={handleSearch} placeholder="Search Agency MPI or Name" />
                </IconField>
                 <MultiSelect
            value={selectedColumns}
            options={allColumns}
            optionLabel="header"
            onChange={onColumnToggle}
            style={{ width: '20em' }}
            placeholder="Show/Hide Columns"
            display="chip"
        />
            </div>
        );
    };

    const pfpDecisionLetterBody = (row:any) =>{
        return <>
            {row.isPfpDecisionLetterPresent && <a style={{cursor: "pointer",textDecoration:"underline", color:"blue"}} onClick={()=>downloadDecisionLetter(row,'PFP')}>{row.providerType}-{reviewYear}-P4P-DecisionLetter.pdf</a>}
        </>
    }

    const pbcDecisionLetterBody = (row: any) => {
        return <>
            {row.isPbcDecisionLetterPresent && <a style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }} onClick={()=>downloadDecisionLetter(row,'PBC')}>{row.providerType}-{reviewYear}-PBC-DecisionLetter.pdf</a>}
        </>
    }

    const pfpResolutionDecisionLetterBody = (row:any) =>{
        return <>
            {row.isPfpResolutionDecisionLetterPresent && <a style={{cursor: "pointer",textDecoration:"underline", color:"blue"}} onClick={()=>downloadDisputeDecisionLetter(row,'PFP')}>{row.providerType}-{reviewYear}-P4P-Resolution-DecisionLetter.pdf</a>}
        </>
    }

    const pbcResolutionDecisionLetterBody = (row: any) => {
        return <>
            {row.isPbcResolutionDecisionLetterPresent && <a style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }} onClick={()=>downloadDisputeDecisionLetter(row,'PBC')}>{row.providerType}-{reviewYear}-PBC-Resolution-DecisionLetter.pdf</a>}
        </>
    }

    const downloadDecisionLetter = (row: any,appType:string) => {
        httpService.getBlob(`${ApiEndpoints.DownloadDecisionLetterFile}/${row.providerMpi}/${appType}/${reviewYear}`).then((response: any) => {
            // Create a blob from the response data
            if(response?.status != 200){
                throw new Error(response);
            }
            const blob = new Blob([response.data]);
            if (blob.size === 0) {
                setShowDialog(true); // Show error dialog if file is empty
                return;
            }
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${row.providerMpi}_${appType}_DecisionLetter.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => {
            setShowDialog(true);
        });
    }

    const downloadDisputeDecisionLetter = (row: any,appType:string) => {
        httpService.getBlob(`${ApiEndpoints.DownloadDisputeDecisionLetterFile}/${row.providerMpi}/${appType}/${reviewYear}`).then((response: any) => {
            // Create a blob from the response data
            if(response?.status != 200){
                throw new Error(response);
            }
            const blob = new Blob([response.data]);
            if (blob.size === 0) {
                setShowDialog(true); // Show error dialog if file is empty
                return;
            }
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${row.providerMpi}_${appType}_Resolution_DecisionLetter.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => {
            setShowDialog(true);
        });
    }

    const downloadAgencyPackage = (row:any) =>{
        httpService.getBlob(`${ApiEndpoints.DownloadProviderZipFile}/${row.pbcProfileId}`)
        .then((response: any) => {
            // Create a blob from the response data
            if(response?.status != 200){
                throw new Error(response);
            }
            const blob = new Blob([response.data]);
            if (blob.size === 0) {
                setShowDialog(true); // Show error dialog if file is empty
                return;
            }
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${row.providerMpi}_${reviewYear}_DataPkg.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => {
            setShowDialog(true);
        });
    }

    const agencyPkgTemplate = (row:any)=>{
        return <>
        <a style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }} onClick={()=>downloadAgencyPackage(row)}>{row.providerMpi}_{reviewYear}_DataPkg.zip</a>
        </>
    }

    const confirm = (appType: string) => {
        setConfirmType(appType);
        setConfirmVisible(true);
    };

    const handleAccept = () => {
        if (confirmType) {
            setConfirmLoading(true);
            SendEmail(confirmType);
        }
    };

    const handleReject = () => {
        setConfirmVisible(false);
        setConfirmLoading(false);
    };

    const SendEmail = (appType:string) =>{
        httpService.get(`${ApiEndpoints.SendEmail}/${appType}/${reviewYear}/${providerType}`)//need dynamic provider type
            .then((resp:any)=>{
                if(resp?.status == 200){
                    getNoticeData();
                }
            })
            .finally(()=>{
                setConfirmVisible(false);
                setConfirmLoading(false);
            })
    }
    
    // const TemplateDate = (dateField: any) => {
    //     if (dateField) {
    //         return new Date(dateField + "Z").toLocaleDateString();
    //     };
    // };

    const To_EST_Time = (dateField: any) => {
        if (dateField) {
            return formatClientLocalDate(dateField);
        }
        return null;
    };

    const pfpStatusTemplate = (row: any) => {
    if (!row.pfpStatus) return null;
    return (
        <>
            {row.pfpStatus.split(',').map((status: string, idx: number) => (
                <div key={idx}>{status.trim()}</div>
            ))}
        </>
    );
};

    const allColumns = useMemo(() => ([
        { field: "providerMpi", header: "Agency MPI" },
        { field: "agencyName", header: "Agency Name" },
        { field: "agencyDataPkg", header: "Agency Data Package", body: agencyPkgTemplate },
        { field: "pbcStatus", header: "Tier Determination" },
        { field: "pfpStatus", header: "P4P Initiative Status", body: pfpStatusTemplate },
        { field: "isPbcDecisionLetterPresent", header: "PBC Decision Letter", body: pbcDecisionLetterBody },
        { field: "pbcDecisionDate", header: "PBC Decision Send Date", dataType: "date", filterPlaceholder: "YYYY-MM-DD", body: (row:any)=>To_EST_Time(row.pbcDecisionDate), filter: true, filterElement: dateFilterTemplate },
        { field: "isPfpDecisionLetterPresent", header: "P4P Decision Letter", body: pfpDecisionLetterBody },
        { field: "pfpDecisionDate", header: "P4P Decision Send Date", dataType: "date", filterPlaceholder: "YYYY-MM-DD", body: (row:any)=>To_EST_Time(row.pfpDecisionDate), filter: true, filterElement: dateFilterTemplate },
        { field: "isPbcResolutionDecisionLetterPresent", header: "PBC Resolution Decision Letter", body: pbcResolutionDecisionLetterBody },
        { field: "pbcResolutionDecisionDate", header: "PBC Resolution Decision Send Date", dataType: "date", filterPlaceholder: "YYYY-MM-DD", body: (row:any)=>To_EST_Time(row.pbcResolutionDecisionDate), filter: true, filterElement: dateFilterTemplate },
        { field: "isPfpResolutionDecisionLetterPresent", header: "P4P Resolution Decision Letter", body: pfpResolutionDecisionLetterBody },
        { field: "pfpResolutionDecisionDate", header: "P4P Resolution Decision Send Date", dataType: "date", filterPlaceholder: "YYYY-MM-DD", body: (row:any)=>To_EST_Time(row.pfpResolutionDecisionDate), filter: true, filterElement: dateFilterTemplate },
    ]), [reviewYear, providerType]);

    // Track selection by field name so it survives allColumns rebuilds when reviewYear changes.
    const [selectedFields, setSelectedFields] = useState<string[]>(() => allColumns.map(c => c.field));
    const selectedColumns = useMemo(
        () => allColumns.filter(col => selectedFields.includes(col.field)),
        [allColumns, selectedFields]
    );
    const onColumnToggle = (event:any) => {
        const fields = event.value.map((col:any) => col.field);
        // Preserve the natural column order defined in allColumns.
        setSelectedFields(allColumns.filter(col => fields.includes(col.field)).map(c => c.field));
    };

    const header = renderHeader();
    return <>
        { isAdministrator() && <div style={{ display:'flex',justifyContent:'flex-end',flexDirection:'column',alignItems:'flex-end',margin:'5px',marginTop: '2%'}}>
            <Button severity="secondary" onClick={()=>confirm("PBC")} disabled={isLoading || !isAdministrator()}>Send PBC Notices</Button><br/>
            <Button severity="secondary" onClick={()=>confirm("PFP")} disabled={isLoading || !isAdministrator()}>Send P4P Notices</Button>
        </div>}
        <div style={{marginTop:'1%'}}>
            <DataTable
                value={noticeFilterData}
                loading={isLoading}
                header={header}
                rows={5}
                rowsPerPageOptions={[5, 10, 25, 50]}
                paginator
                emptyMessage="No data present"
                filters={filters}
                globalFilterFields={['providerType', 'providerMpi', 'pbcStatus', 'pfpStatus','pbcDecisionDate','pfpDecisionDate','agencyDataPkg','pfpResolutionDecisionDate','pbcResolutionDecisionDate']}
            >
                <Column field="pbcProfileId" style={{display:"none"}} header="PBC Provider Profile ID" sortable filter></Column>
                {selectedColumns.map(col => (
                    <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={col.body}
                        dataType={col.dataType}
                        filterPlaceholder={col.filterPlaceholder}
                        sortable
                        filter={col.filter}
                        filterElement={col.filterElement}
                    />
                ))}
            </DataTable>
            <Dialog header="File not found!" visible={showDialog} onHide={() => {setShowDialog(false)}}>
                        <div>
                          <p>{Constants.FILE_NOT_FOUND_ERROR}</p>
                        </div>
            </Dialog>
            <Dialog
                header={`Confirm ${confirmType == "PFP" ? "P4P": confirmType} Notice Distribution`}
                visible={confirmVisible}
                onHide={handleReject}
                modal
                style={{ width: '400px' }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#f8c471' }} />
                    <p>{`Please CONFIRM ${confirmType} Notices are ready to send`}</p>
                    {confirmLoading && <ProgressSpinner style={{width: '30px', height: '30px'}} strokeWidth="4" />}
                    <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                        <Button
                            label="CONFIRM & SEND"
                            className="p-button-secondary"
                            onClick={handleAccept}
                            disabled={confirmLoading}
                        />
                        <Button
                            label="CANCEL"
                            className="p-button-secondary"
                            onClick={handleReject}
                            disabled={confirmLoading}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    </>
}